/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import axios from 'axios';
import axiosRetry from 'axios-retry';
import { integrationAdaptersApiPath } from '../settings';
import { getAccessToken } from '../redux/features/auth/auth.service';

const axiosInstance = axios.create(); // Create an axios instance

axiosRetry(axiosInstance, {
  retries: 3, // Define how many times you want to retry
  retryDelay: (retryCount) => {
    return axiosRetry.exponentialDelay(retryCount);
  },
  retryCondition: (error) => {
    return axiosRetry.isRetryableError(error) && !axios.isCancel(error);
  },
});

const getHeaders = () => {
  const token = getAccessToken();
  return {
    'Cache-Control': 'no-cache',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

let cancel;

export default {
  validate: async (endpoint) => {
    if (cancel !== undefined) {
      cancel('Operation canceled due to new request.');
    }

    return axiosInstance
      .get(`${integrationAdaptersApiPath}/${endpoint}`, {
        cancelToken: new axios.CancelToken(function executor(c) {
          cancel = c;
        }),
        headers: getHeaders(),
      })
      .then(response => response?.data === 0 || null)
      .catch((error) => {
        if (axios.isCancel(error)) {
          // eslint-disable-next-line no-console
          console.log('Request canceled:', error.message);
        }
        // Resolve to true when there's an error
        return Promise.resolve(true);
      });
  },
};
